import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosInstance";
import {
  ChevronLeft,
  ChevronRight,
  Clock,
  Phone,
  ArrowRight,
  Sparkles,
  MapPin,
  Users,
  ChefHat,
  Wine,
  UtensilsCrossed,
  Facebook,
  Instagram,
  Globe,
  Heart,
  Award,
  Shield,
  Leaf,
  Menu,
} from "lucide-react";

const Restaurant = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);

  const carouselImages = [
    {
      id: 1,
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.59_PM-min_trljoi.jpg",
      title: "Luxury Interior",
      description: "Elegant ambiance with golf course views",
    },
    {
      id: 2,
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.46_PM-min_sjhcpy.jpg",
      title: "Fine Dining Experience ",
      description: "Sophisticated decor and comfortable seating",
    },
    {
      id: 3,
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.58.00_PM-min_geltlb.jpg",
      title: "Panoramic Views",
      description: "Breathtaking golf course scenery",
    },
  ];

  const socialLinks = {
    facebook: "https://www.facebook.com/share/1662ufVo5d/",
    google:
      "https://www.google.com/search?client=ms-android-samsung-ss&sca_esv=792560e52f66799b&sxsrf=AE3TifNv58Ko7EeX8f394r4noIFaQaAFUw:1758516474210&q=golf+view+resturant+rajendrapur+reviews&uds=AOm0WdGzFl_-Sc0JzSQUtxIBG54-XHrujKkELGtZrSO9oRqEzibxezfF8p4iOUCEoBo7lidWL-fwmLeAJUofOxy-l4inlAoAgSWI_W8ytsdlrZddxrx7TZhuM-ByTCGOOQvk1nOxMA4M_Pk10mluSNYhIBzw5Nivh6B4ZHxyY0zVUjGCY2wjQDxblPPXWP6bWfF5nrqeVkPv6F1OdaB3EY0er5oatpmY9g3xAWx_9nwOA4aGpLAOwIPIycwFzOS_k65xwtdIa8gAY6GElVRMhwt8hSLD0K4_SqWsL6UnYVoVnfT6Vv21atIHU3zOAv2q-k2GHUEajonZ9RzQ8Zb4mIWUn6qqKAThWaCyjwdR9-aLbE40MoQs1yA&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E5mQcxaHtBrcNvx_OLntQwhOtCTztzaXCLvEQgSI42QHMCoVTQZ7pOOnnxYuMnntQNHDJk2zzknvDvt2OzpNKM6OK0Sl_ZBj-BHA6m0rfCHcSK5zHA%3D%3D&sa=X&ved=2ahUKEwi2spuuyOuPAxV1yzgGHbXCEC8Qk8gLegQIGhAB&ictx=1&biw=384&bih=695&dpr=2.81",
    instagram:
      "https://www.instagram.com/golf.viewrestaurant?igsh=MWgweWFoc2RneGJyNQ==",
  };

  const features = [
    {
      icon: <Leaf className="w-6 h-6" />,
      title: "Fresh Ingredients",
      description: "Locally sourced, premium quality",
      color: "from-emerald-500 to-lime-500",
      bg: "bg-gradient-to-br from-emerald-50 to-lime-50",
    },
    {
      icon: <ChefHat className="w-6 h-6" />,
      title: "Expert Chefs",
      description: "Skilled culinary masters",
      color: "from-amber-500 to-orange-500",
      bg: "bg-gradient-to-br from-amber-50 to-orange-50",
    },
    {
      icon: <Wine className="w-6 h-6" />,
      title: "Fine Selection",
      description: "Premium beverages & wine",
      color: "from-purple-500 to-pink-500",
      bg: "bg-gradient-to-br from-purple-50 to-pink-50",
    },
  ];

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get("/restaurant/categories/get/all");
        setCategories(res.data);
      } catch (err) {
        console.error("Failed to load categories:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? carouselImages.length - 1 : prev - 1
    );
  };

  const handleSocialClick = (platform) => {
    window.open(socialLinks[platform], "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-30"></div>
            <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 flex items-center justify-center">
              <UtensilsCrossed className="w-10 h-10 text-emerald-600 animate-pulse" />
            </div>
          </div>
          <p className="text-gray-600 text-lg mt-6">
            Preparing your dining experience...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-2xl">
                <UtensilsCrossed className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Golf View{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Cafe & Restaurant</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-emerald-100 max-w-3xl mx-auto mb-8">
            Experience exquisite dining with panoramic golf course views and
            premium culinary delights
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-emerald-200">
              <Award className="w-5 h-5" />
              <span>Fine Dining</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <MapPin className="w-5 h-5" />
              <span>Riverside Views</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <Shield className="w-5 h-5" />
              <span>Premium Quality</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Left Sidebar - Menu & Social */}
          <div className="lg:col-span-1">
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-emerald-100 sticky top-8">
              {/* Social Media Section */}
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-6">
                  <Sparkles className="w-5 h-5 text-emerald-500" />
                  <h3 className="text-xl font-bold text-gray-900">
                    Connect With Us
                  </h3>
                  <Sparkles className="w-5 h-5 text-emerald-500" />
                </div>

                <div className="grid grid-cols-3 gap-4">
                  {/* Facebook */}
                  <button
                    onClick={() => handleSocialClick("facebook")}
                    className="group bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                  >
                    <div className="flex flex-col items-center">
                      <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center mb-3">
                        <Facebook className="w-6 h-6 text-white" />
                      </div>
                      <span className="text-sm font-semibold text-gray-700">
                        Facebook
                      </span>
                      <span className="text-xs text-gray-500 mt-1">
                        Reviews
                      </span>
                    </div>
                  </button>

                  {/* Google */}
                  <button
                    onClick={() => handleSocialClick("google")}
                    className="group bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-4 border border-red-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                  >
                    <div className="flex flex-col items-center">
                      <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center mb-3">
                        <Globe className="w-6 h-6 text-white" />
                      </div>
                      <span className="text-sm font-semibold text-gray-700">
                        Google
                      </span>
                      <span className="text-xs text-gray-500 mt-1">
                        Reviews
                      </span>
                    </div>
                  </button>

                  {/* Instagram */}
                  <button
                    onClick={() => handleSocialClick("instagram")}
                    className="group bg-gradient-to-br from-pink-50 to-purple-100 rounded-xl p-4 border border-pink-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                  >
                    <div className="flex flex-col items-center">
                      <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-pink-500 to-purple-500 flex items-center justify-center mb-3">
                        <Instagram className="w-6 h-6 text-white" />
                      </div>
                      <span className="text-sm font-semibold text-gray-700">
                        Instagram
                      </span>
                      <span className="text-xs text-gray-500 mt-1">
                        Gallery
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              {/* Menu Explorer */}
              <div className="pt-6 border-t border-gray-100">
                <div className="text-center mb-6">
                  <div className="flex items-center justify-center gap-3 mb-4">
                    <Menu className="w-5 h-5 text-emerald-500" />
                    <h3 className="text-2xl font-bold text-gray-900">
                      Explore Our Menu
                    </h3>
                    <Menu className="w-5 h-5 text-emerald-500" />
                  </div>
                  <p className="text-gray-600 mb-6">
                    Discover our carefully curated culinary offerings
                  </p>
                </div>

                <button
                  onClick={() => navigate("/menu-gallery")}
                  className="group relative w-full bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <span className="relative flex items-center justify-center gap-3">
                    <span className="text-lg">View Full Menu</span>
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="lg:col-span-2 space-y-8">
            {/* Carousel Section */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-4 md:p-6 border border-emerald-100 overflow-hidden group">
              <div className="relative">
                {/* Image Slider */}
                <div className="relative h-80 md:h-96 lg:h-[500px] rounded-xl overflow-hidden">
                  {carouselImages.map((item, index) => (
                    <div
                      key={item.id}
                      className={`absolute inset-0 transition-opacity duration-1000 ${
                        index === currentSlide ? "opacity-100" : "opacity-0"
                      }`}
                      onClick={() => setSelectedImage(item.image)}
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover cursor-pointer transform transition-transform duration-700 group-hover:scale-105"
                      />
                      {/* Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent">
                        <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                          <h3 className="text-xl font-bold mb-2">
                            {item.title}
                          </h3>
                          <p className="text-emerald-100">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Navigation Arrows */}
                <button
                  onClick={prevSlide}
                  className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-xl"
                >
                  <ChevronLeft className="w-6 h-6" />
                </button>
                <button
                  onClick={nextSlide}
                  className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-xl"
                >
                  <ChevronRight className="w-6 h-6" />
                </button>

                {/* Dots Indicator */}
                <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-3">
                  {carouselImages.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentSlide(idx)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        idx === currentSlide
                          ? "w-8 bg-gradient-to-r from-emerald-500 to-lime-500"
                          : "bg-white/60 hover:bg-white/80"
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Info Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Opening Hours Card */}
              <div
                className={`bg-gradient-to-br from-emerald-500 to-lime-500 rounded-2xl p-6 md:p-8 text-white shadow-2xl transition-all duration-500 transform ${
                  hoveredCard === "hours" ? "-translate-y-2" : ""
                }`}
                onMouseEnter={() => setHoveredCard("hours")}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="flex items-center mb-8">
                  <div className="w-14 h-14 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center mr-5">
                    <Clock className="w-7 h-7" />
                  </div>
                  <div>
                    <h2 className="text-2xl md:text-3xl font-bold">
                      Opening Hours
                    </h2>
                    <p className="text-emerald-100 mt-1">Plan your visit</p>
                  </div>
                </div>

                <div className="space-y-5">
                  <div className="flex justify-between items-center py-3 border-b border-white/20">
                    <div>
                      <div className="font-semibold text-lg">
                        Saturday - Thursday
                      </div>
                      <div className="text-emerald-100 text-sm">
                        Main Dining Hours
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-semibold">8:00 AM - 12:00 AM</div>
                      <div className="text-sm text-emerald-100">
                        3:00 PM - 10:00 PM
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3">
                    <div>
                      <div className="font-semibold text-lg">Friday</div>
                      <div className="text-emerald-100 text-sm">
                        Special Hours
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-semibold">8:00 AM - 10:00 AM</div>
                      <div className="text-sm text-emerald-100">
                        3:00 PM - 10:00 PM
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Reservation Card */}
              <div
                className={`bg-gradient-to-br from-blue-500 to-indigo-500 rounded-2xl p-6 md:p-8 text-white shadow-2xl transition-all duration-500 transform ${
                  hoveredCard === "reservation" ? "-translate-y-2" : ""
                }`}
                onMouseEnter={() => setHoveredCard("reservation")}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="flex items-center mb-8">
                  <div className="w-14 h-14 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center mr-5">
                    <Phone className="w-7 h-7" />
                  </div>
                  <div>
                    <h2 className="text-2xl md:text-3xl font-bold">
                      Reservations
                    </h2>
                    <p className="text-blue-100 mt-1">Book your table</p>
                  </div>
                </div>

                <div className="space-y-6">
                  <p className="text-lg leading-relaxed">
                    Reserve your table in advance for the perfect dining
                    experience
                  </p>

                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 text-center hover:bg-white/15 transition-colors duration-300">
                    <div className="text-2xl md:text-3xl font-bold mb-3">
                      +88 01769660126
                    </div>
                    <div className="flex items-center justify-center gap-2 text-blue-100">
                      <Users className="w-4 h-4" />
                      <span>Call now to book your table</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Features Grid */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-emerald-100">
              <div className="text-center mb-8">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  Why Choose Golf View Cafe?
                </h3>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Experience premium dining with exceptional service and
                  ambiance
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className={`${feature.bg} rounded-2xl p-6 border border-gray-100 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-500 group`}
                  >
                    <div className="w-16 h-16 rounded-xl bg-white flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <div
                        className={`bg-gradient-to-r ${feature.color} bg-clip-text text-transparent`}
                      >
                        {feature.icon}
                      </div>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-3">
                      {feature.title}
                    </h4>
                    <p className="text-gray-600">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Review Button */}
      <button
        onClick={() => navigate("/review")}
        className="fixed top-20 right-4 z-50 px-6 py-3 md:px-8 md:py-4 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 shadow-2xl hover:shadow-3xl hover:scale-105 transition-all duration-300 flex items-center gap-3 group"
      >
        <Heart className="w-5 h-5 group-hover:animate-pulse" />
        <span>Rate & Review</span>
        <Heart className="w-5 h-5 group-hover:animate-pulse" />
      </button>

      {/* Floating Contact Button - number always visible, no click needed */}
      <a
        href="tel:01769660126"
        className="fixed bottom-4 right-4 lg:top-1/2 lg:bottom-auto lg:-translate-y-1/2 z-50 flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-lime-500 text-white px-5 py-3 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105"
      >
        <Phone className="w-5 h-5 flex-shrink-0" />
        <span className="font-semibold whitespace-nowrap">
          Contact us - 01769-660126
        </span>
      </a>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-6xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute -top-12 right-0 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
              onClick={() => setSelectedImage(null)}
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <img
              src={selectedImage}
              alt="Enlarged view"
              className="w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Restaurant;
